import Spinners from "components/Common/Spinner"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import toast from "react-hot-toast"
import { designationMap } from "helpers/common"
import KYCPrevButton from "./kycPrevButton"
import { useUpdateBusinessSignatoryOnboardedInvestorMutation } from "store/api/wealthpartnerapi/onboard.api"

const defaultValues = {
  designation: "",
  dpin: "",
}

const AuthorisedSignatory = ({ kycData }) => {
  const [companyType, setCompanyType] = useState("")
  const [designations, setDesignations] = useState([])
  const [updateBusinessSignatory, { isLoading }] =
    useUpdateBusinessSignatoryOnboardedInvestorMutation()

  useEffect(() => {
    if (kycData) {
      const constitutionOfBusiness =
        kycData?.companyAdditionalDetails?.constitution_of_business ||
        "Private Limited Company"
      setCompanyType(constitutionOfBusiness)
    }
  }, [kycData])

  useEffect(() => {
    validation.setValues({
      designation: kycData?.companyAdditionalDetails.designation,
      dpin: kycData?.companyAdditionalDetails.dpin,
    })
  }, [kycData])

  useEffect(() => {
    const items = designationMap[companyType] || []
    setDesignations(items)
  }, [companyType])

  const validation = useFormik({
    initialValues: { ...defaultValues },
    validationSchema: Yup.object({}),
    validateOnMount: false,
    onSubmit: async (values) => {
      onFormUpdate(values)
    },
  })

  const onFormUpdate = async (values) => {
    try {
      const { success } = await updateBusinessSignatory({
        ...values,
        id: kycData.investor_id,
      }).unwrap()

      if (success) {
        window.location.reload()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <>
      <Row>
        <div className="bank-details-wrapper">
          <h5 className="title">Authorised Person KYC</h5>
          <p>Select the designation of the authorised person to proceed.</p>
          <Form
            onSubmit={(e) => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <Col xl={12}>
              <Label className="col-form-label">
                Designation <span className="error">*</span>
              </Label>
              <select
                name="designation"
                className={`form-select pageSize ${
                  validation.touched.designation &&
                  validation.errors.designation &&
                  "is-invalid"
                }`}
                value={validation.values.designation}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
              >
                <option value=""> Select </option>
                {designations.map((item, index) => (
                  <option key={`designations_${index}`} value={item}>
                    {item}
                  </option>
                ))}
              </select>

              {validation.touched.designation &&
              validation.errors.designation ? (
                <FormFeedback type="invalid">
                  {validation.errors.designation}
                </FormFeedback>
              ) : null}
            </Col>
            {["Designated Partner", "Director"].includes(
              validation.values.designation
            ) && (
              <Col xl={12}>
                <Label className="col-form-label">DIN</Label>
                <Input
                  name="dpin"
                  type="text"
                  className="form-control"
                  placeholder="Enter DIN"
                  value={validation.values.dpin}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.dpin && validation.errors.dpin
                      ? true
                      : false
                  }
                />
                {validation.touched.dpin && validation.errors.dpin ? (
                  <FormFeedback type="invalid">
                    {validation.errors.dpin}
                  </FormFeedback>
                ) : null}
                <span
                  className="text-muted"
                  style={{
                    fontStyle: "italic",
                  }}
                >
                  Provide the required details for the individual linked to the
                  selected DIN and complete the KYC in the next steps.
                </span>
              </Col>
            )}
            <Col sm={12}>
              <Row className="mt-4">
                <KYCPrevButton
                  kycData={kycData}
                  disabled={isLoading}
                  ButtonHtml={
                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      disabled={isLoading}
                    >
                      {isLoading ? <Spinners /> : "Save & Next"}
                    </button>
                  }
                />
              </Row>
            </Col>
          </Form>
        </div>
      </Row>
    </>
  )
}

export default AuthorisedSignatory
